import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL ?? import.meta.env.VITE_API_URL ?? 'http://127.0.0.1:54321';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-key-for-dev';

let logtoToken: string | undefined;
let supabaseToken: string | undefined;

export function setSupabaseAccessToken(token: string | undefined) {
  logtoToken = token;
}

export function setSupabaseDbToken(token: string | undefined) {
  supabaseToken = token;
  if (token) {
    supabase.realtime.setAuth(token);
  }
}

type AuthExpiryHandler = () => Promise<{ logtoToken: string; supabaseToken: string } | null>;
let authExpiryHandler: AuthExpiryHandler | undefined;
let refreshInFlight: Promise<{ logtoToken: string; supabaseToken: string } | null> | null = null;

export function setAuthExpiryHandler(handler: AuthExpiryHandler | undefined) {
  authExpiryHandler = handler;
}

const authFetch: typeof fetch = async (input, init) => {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
  const isResolveSession = url.includes('/functions/v1/resolve-session');
  const token = isResolveSession ? logtoToken : supabaseToken;

  if (token) {
    const headers = new Headers(init?.headers);
    headers.set('Authorization', `Bearer ${token}`);
    const response = await fetch(input, { ...init, headers });

    if (!isResolveSession && response.status === 401 && authExpiryHandler) {
      if (!refreshInFlight) {
        refreshInFlight = authExpiryHandler().finally(() => {
          refreshInFlight = null;
        });
      }
      const tokens = await refreshInFlight;
      if (tokens) {
        logtoToken = tokens.logtoToken;
        supabaseToken = tokens.supabaseToken;
        const retryHeaders = new Headers(init?.headers);
        retryHeaders.set('Authorization', `Bearer ${tokens.supabaseToken}`);
        return fetch(input, { ...init, headers: retryHeaders });
      }
    }
    return response;
  }
  return fetch(input, init);
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
  },
  global: {
    fetch: authFetch,
  },
});
